
import { TranslationsByLanguage } from './types';

export type CreateDerivativeTranslationKey =
  | 'createDerivative.title'
  | 'createDerivative.uploadYourVersion'
  | 'createDerivative.uploadDescription'
  | 'createDerivative.titleLabel'
  | 'createDerivative.titlePlaceholder'
  | 'createDerivative.descriptionLabel'
  | 'createDerivative.descriptionPlaceholder'
  | 'createDerivative.fileLabel'
  | 'createDerivative.fileRequirements'
  | 'createDerivative.submit'
  | 'createDerivative.uploading'
  | 'createDerivative.error'
  | 'createDerivative.fileTooLarge'
  | 'createDerivative.invalidFileType'
  | 'createDerivative.maxSize';

export const createDerivativeTranslations: TranslationsByLanguage = {
  en: {
    'createDerivative.title': 'Publish Creation',
    'createDerivative.uploadYourVersion': 'Upload your creation',
    'createDerivative.uploadDescription': 'Showcase your derivative work',
    'createDerivative.titleLabel': 'Title',
    'createDerivative.titlePlaceholder': 'Give your derivative a title',
    'createDerivative.descriptionLabel': 'Description',
    'createDerivative.descriptionPlaceholder': 'Describe your derivative',
    'createDerivative.fileLabel': 'Video File',
    'createDerivative.fileRequirements': 'Upload a video file (MP4, MOV, AVI, WebM, MPEG or OGG recommended)',
    'createDerivative.submit': 'Submit Derivative',
    'createDerivative.uploading': 'Uploading...',
    'createDerivative.error': 'Error',
    'createDerivative.fileTooLarge': 'File size exceeds maximum limit',
    'createDerivative.invalidFileType': 'Please upload a valid video file (MP4, MOV, AVI, WebM, MPEG or OGG)',
    'createDerivative.maxSize': 'Maximum size:'
  },
  fr: {
    'createDerivative.title': 'Publier une création',
    'createDerivative.uploadYourVersion': 'Télécharger votre création',
    'createDerivative.uploadDescription': 'Mettez en avant votre création dérivée',
    'createDerivative.titleLabel': 'Titre',
    'createDerivative.titlePlaceholder': 'Donnez un titre à votre dérivé',
    'createDerivative.descriptionLabel': 'Description',
    'createDerivative.descriptionPlaceholder': 'Décrivez votre dérivé',
    'createDerivative.fileLabel': 'Fichier Vidéo',
    'createDerivative.fileRequirements': 'Téléchargez un fichier vidéo (MP4, MOV, AVI, WebM, MPEG ou OGG recommandé)',
    'createDerivative.submit': 'Soumettre le Dérivé',
    'createDerivative.uploading': 'Téléchargement en cours...',
    'createDerivative.error': 'Erreur',
    'createDerivative.fileTooLarge': 'La taille du fichier dépasse la limite maximale',
    'createDerivative.invalidFileType': 'Veuillez télécharger un fichier vidéo valide (MP4, MOV, AVI, WebM, MPEG ou OGG)',
    'createDerivative.maxSize': 'Taille maximale :'
  }
};
